export default "__VITE_ASSET__hIRra3e1__"